<template>
  <div class="login-body">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(cadastrar)">
        <div class="card-novo-usuario ">
          <div id="cardCadastro" class="card shadow-8 p-fluid grid formgrid " >
            <h1>Novo usuário</h1>
            <div class="p-fluid formgrid grid">
              <transition-group name="p-messages" tag="div">
                <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">
                  {{ msg.content }}
                </Message>
              </transition-group>

              <div class="field col-12">
                <label for="nome" class="required">Nome Completo</label>
                <ValidationProvider
                  name="Nome"
                  rules="required|min:10"
                  v-slot="{ errors, classes }"
                  mode="lazy"
                >
                  <InputText
                    id="nome"
                    v-model.lazy="usuario.nome"
                    type="text"
                    :class="classes"
                  />
                  <InlineMessage v-if="errors[0]">{{
                    errors[0]
                  }}</InlineMessage>
                </ValidationProvider>
              </div>
              <div class="field col-12 md:col-2">
                <label for="data_nascimento" class="required">Data Nascimento</label>
                <ValidationProvider
                  name="Data Nascimento"
                  rules="required|data_nascimento"
                  v-slot="{ errors }"
                  mode="lazy"
                >
                  <InputMask
                    id="data_nascimento"
                    v-model.lazy="usuario.data_nascimento"
                    mask="99/99/9999"
                    :class="{ 'field-invalid': errors[0] }"
                  />
                  <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                </ValidationProvider>
              </div>
              <div class="field col-12 md:col-2">
                <label for="Sexo" class="required">Sexo</label>
                <ValidationProvider name="Sexo" rules="required" v-slot="{ errors }" mode="lazy">
                  <Dropdown id="sexo"
                    v-model="usuario.sexo"
                    :options="dropdownSexo"
                    optionLabel="name"
                    placeholder="Sexo ..."
                    :class="{ 'field-invalid': errors[0] }"/>
                  <InlineMessage v-if="errors[0]">{{errors[0]}}</InlineMessage>
                </ValidationProvider>
              </div>
              <div class="field col-12 md:col-3">
                <label for="cpf" class="required">CPF</label>
                <ValidationProvider name="CPF"  rules="required|cpf" v-slot="{ errors }" mode="lazy">
                  <InputMask id="cpf" v-model="usuario.cpf"
                    mask="999.999.999-99" :class="{ 'field-invalid': errors[0] }"/>
                  <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                </ValidationProvider>
              </div>
              <div class="field col-12 md:col-3">
                <label for="rg" class="required">RG</label>
                <ValidationProvider name="RG" rules="required" v-slot="{ errors }" mode="lazy">
                  <InputNumber id="rg" v-model="usuario.rg" :class="{ 'field-invalid': errors[0] }"/>
                  <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                </ValidationProvider>
              </div>

              <div class="field col-12 md:col-2">
                <label for="Celular" class="required">Celular</label>
                <ValidationProvider
                  name="Celular"
                  rules="required"
                  v-slot="{ errors }"
                  mode="lazy">
                  <InputMask id="celular" v-model="usuario.celular" mask="(99) 99999-9999" :class="{ 'field-invalid': errors[0] }"/>
                  <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                </ValidationProvider>
              </div>

              <StateCity :usuario="usuario"></StateCity>

              <div class="field col-6">
                <label for="email" class="required">E-mail</label>
                <ValidationProvider
                  name="E-mail"
                  rules="required|email"
                  vid="email"
                  v-slot="{ errors }"
                  mode="lazy"
                >
                  <InputText
                    id="email"
                    v-model="usuario.email"
                    :class="{ 'field-invalid': errors[0] }"
                  />
                  <InlineMessage v-if="errors[0]">{{
                    errors[0]
                  }}</InlineMessage>
                </ValidationProvider>
              </div>

              <div class="field col-6">
                <label for="email" class="required">Redigite o E-mail</label>
                <ValidationProvider
                  name="Redigite o E-mail"
                  rules="required|confirmed:email"
                  v-slot="{ errors }"
                  mode="lazy"
                >
                  <InputText
                    id="confirmeEmail"
                    v-model="usuario.confirmeEmail"
                    type="email"
                    :class="{ 'field-invalid': errors[0] }"
                  />
                  <InlineMessage v-if="errors[0]">{{
                    errors[0]
                  }}</InlineMessage>
                </ValidationProvider>
              </div>
              <div class="field col-6 min-h-1000 ">
                <label for="senha" class="required">Senha</label>
                <ValidationProvider
                  name="Senha"
                  rules="required|min:8"
                  vid="pass"
                  v-slot="{ errors }"
                  mode="lazy"
                >
                  <InputText
                    id="senha"
                    v-model="usuario.senha"
                    type="password"
                    :class="{ 'field-invalid': errors[0] }"
                  />
                  <InlineMessage v-if="errors[0]">{{
                    errors[0]
                  }}</InlineMessage>
                </ValidationProvider>
              </div>
              <div class="field col-6">
                <label for="senha" class="required">Redigite a Senha</label>
                <ValidationProvider
                  name="Redigite a Senha"
                  rules="required|confirmed:pass"
                  v-slot="{ errors }"
                  mode="lazy"
                >
                  <InputText
                    id="senha2"
                    type="password"
                    v-model="usuario.confirmeSenha"
                    :class="{ 'field-invalid': errors[0] }"
                  />
                  <InlineMessage v-if="errors[0]">{{
                    errors[0]
                  }}</InlineMessage>
                </ValidationProvider>
              </div>
            </div>
            <div class="field col-12 md:col-2">
              <Button
                label="Cadastrar"
                icon="pi pi-check"
                iconPos="left"
                type="submit"
              ></Button>
            </div>
            <div class="field col-12 md:col-2">
              <router-link :to="{ name: 'login' }">
                <Button
                  label="Login"
                  icon="pi pi-arrow-circle-left"
                  iconPos="left"
                  class="p-button-secondary mr-4"
                ></Button>
              </router-link>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import StateCity from "../components/StateCity.vue";

import { logoutMixin } from "@/mixins";
import { validacaoFormulario } from "@/validacaoFormulario";
import http from "@/http";

export default {
  mixins: [logoutMixin, validacaoFormulario],

  components: {
    StateCity: StateCity,

  },

  data() {
    return {
      messages: [],
      usuario: {
        nome: "",
        senha: "",
        confirmeSenha: "",
        email: "",
        confimeEmail: "",
        cpf: "",
        rg: "",
        data_nascimento: "",
        cep: "",
        logradouro: "",
        numero: null,
        complemento: "",
        bairro: "",
        uf: "",
        estado: "",
        cidade: "",
        celular: "",
      },
      dropdownSexo: [
        { name: "Feminino", code: "F" },
        { name: "Masculino", code: "M" },
      ],
    };
  },

  methods: {
    cadastrar() {
      this.messages = [];
      http
        .post("usuario", this.usuario)
        .then((resposta) => {
          console.log("Status: " + resposta.request.status);
          alert("Cadastro realizado com sucesso! Você receberá um e-mail com o link para confirmação do e-mail cadastrado.");
          this.$router.push({ name: "login" });
        })
        .catch((erro) => {
          console.error(erro);
          if (erro.response) {
            // API respondeu
            if (erro.response.data.errors) {
              this.addMessageError(erro.response.data.errors); //vários erros
            } else {
              //apenas a mensagem de erro
              if (erro.response.data.message) {
                this.messages = [
                  { severity: "error", content: erro.response.data.message },
                ];
              } else {
                this.messages = [
                  {
                    severity: "error",
                    content:
                      "Um erro inesperado aconteceu! Tente novamente mais tarde.",
                  },
                ];
              }
            }
          } else {
            //API não respondeu
            this.messages = [
              {
                severity: "error",
                content: "Sistema indisponível! Tente novamente mais tarde.",
              },
            ];
            this.messages = [
              {
                severity: "error",
                content: "Sistema indisponível! Tente novamente mais tarde.",
              },
            ];
            this.messages = [
              {
                severity: "error",
                content: "Sistema indisponível! Tente novamente mais tarde.",
              },
            ];
          }
        });
    },

    addMessageError(errors) {
      for (let i = 0; i < errors.length; i++) {
        this.messages.push({
          severity: "error",
          content: `${errors[i].message}`,
        });
      }
    },
  },
};
</script>

<style>

@media screen and (min-width: 800px)
{
    #cardCadastro {
        /* background-color: lightblue,*/
        height: 800px
    }
}

</style>